import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import {
  clearErrorMessage,
  clearSuccessMessage,
  Context,
  createTeacher,
  CREATE_TEACHER_SUCCESS_MESSAGE,
  ITeacherParam,
  teachersPath,
} from "../../../managerStore";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import TeacherForm from "../../../templates/manager/TeacherForm";
import useWaitApiCall from "../../../hooks/useWaitApiCall";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const history = useHistory();
  React.useEffect(() => {
    if (state.success_message === CREATE_TEACHER_SUCCESS_MESSAGE) {
      dispatch(clearSuccessMessage());
      history.push(teachersPath);
    }
  }, [history, dispatch, state.success_message]);

  const createTeacherFunc = React.useCallback(
    (userManager: ITeacherParam) => {
      dispatch(peep(createTeacher(userManager)));
    },
    [dispatch, peep],
  );

  React.useEffect(() => {
    return () => dispatch(clearErrorMessage());
  }, [dispatch]);

  return (
    <div>
      <Breadcrumb
        links={[{ title: titles.teachers, to: teachersPath }]}
        currentTitle={titles.newTeacher}
      />
      <TeacherForm
        title={titles.newTeacher}
        calling={calling}
        error={state.error}
        upsertTeacher={createTeacherFunc}
      />
    </div>
  );
};
